import Vue from 'vue'
import VueRouter from 'vue-router'

// Authentication
import Auth from './auth'

// AI Agent
import AIAgent from './ai-agent'

Vue.use(VueRouter)

const routes = [

  // Root
  {
    path: '/',
    redirect: { name: 'ai-agent' }
  },

  // Authentication
  ...Auth,

  // AI Agent
  ...AIAgent
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  const currentRoute = to.path
  const loggedIn = localStorage.getItem('accessToken')
  const publicRoutes = ['/auth/sso', '/auth/sso-error']
  const isPublicRoute = publicRoutes.includes(currentRoute)

  if (!isPublicRoute && !loggedIn) {
    next('/auth/sso-error')
  } else {
    next()
  }
})

export default router
